
<template lang="pug">

	div.container#app
		router-view(:app-state="state")

</template>


<script>
	import { stores } from '../stores/MainStore.js'

	export default {

		created: function() {
			var self = this;

			stores.config.$router = self.$router;
			this.state = stores.getInitialState();

			self.$router.beforeEach((to, from, next) => {
				if ( to.name!='home' && to.name.search("doc") === -1 && ( self.state === null || (!self.state.user && !self.state.isLoading)) ) {
					console.warn("invalid state -> redirect home");
					self.$router.push('/home');
				}
				next();
			});

			// check for user session or redirect to login page
			if ( !self.state.user && self.$route.name!='home' && self.$route.name.search("doc")===-1 ) {
				console.warn("session out -> redirect home")
				self.$router.push('/home');
			}

		},

		data() {
			return {
				state: {}
				// isPreHome: true
			}

		}

	}

</script>

<style lang="stylus">

@font-face
    font-family: 'ComfortaaLight'
    src: url('../assets/fonts/comfortaa-light.eot')
    src: url('../assets/fonts/comfortaa-light.eot?#iefix') format('embedded-opentype'), url('../assets/fonts/comfortaa-light.woff')  format('woff'), url('../assets/fonts/comfortaa-light.ttf') format('truetype'), url('../assets/fonts/comfortaa-light.svg#comfortaalight') format('svg')
    font-weight: normal
    font-style: normal

@font-face
    font-family: 'ComfortaaBold'
    src: url('../assets/fonts/comfortaa-bold.eot')
    src: url('../assets/fonts/comfortaa-bold.eot?#iefix') format('embedded-opentype'), url('../assets/fonts/comfortaa-bold.woff')  format('woff'), url('../assets/fonts/comfortaa-bold.ttf') format('truetype'), url('../assets/fonts/comfortaa-bold.svg#comfortaalight') format('svg')
    font-weight: normal
    font-style: normal

@font-face
	font-family: 'Roboto';
	src: url('../assets/fonts/Roboto-Regular-webfont.eot');
	src: url('../assets/fonts/Roboto-Regular-webfont.eot?#iefix') format('embedded-opentype'),
			url('../assets/fonts/Roboto-Regular-webfont.woff') format('woff'),
			url('../assets/fonts/Roboto-Regular-webfont.ttf') format('truetype'),
			url('../assets/fonts/Roboto-Regular-webfont.svg#robotoregular') format('svg');
	font-weight: normal;
	font-style: normal;

@font-face
    font-family: 'Outfit-Bold';
    src: url('../assets/fonts/Outfit-Bold.eot');
    src: url('../assets/fonts/Outfit-Bold.eot?#iefix') format('embedded-opentype'),
            url('../assets/fonts/Outfit-Bold.svg#Outfit-Bold') format('svg'),
            url('../assets/fonts/Outfit-Bold.ttf') format('truetype'),
            url('../assets/fonts/Outfit-Bold.woff') format('woff'),
            url('../assets/fonts/Outfit-Bold.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;

@font-face
    font-family: 'Outfit-Regular';
    src: url('../assets/fonts/Outfit-Regular.eot');
    src: url('../assets/fonts/Outfit-Regular.eot?#iefix') format('embedded-opentype'),
            url('../assets/fonts/Outfit-Regular.svg#Outfit-Regular') format('svg'),
            url('../assets/fonts/Outfit-Regular.ttf') format('truetype'),
            url('../assets/fonts/Outfit-Regular.woff') format('woff'),
            url('../assets/fonts/Outfit-Regular.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;

@font-face
    font-family: 'Outfit-Light';
    src: url('../assets/fonts/Outfit-Light.eot');
    src: url('../assets/fonts/Outfit-Light.eot?#iefix') format('embedded-opentype'),
            url('../assets/fonts/Outfit-Light.svg#Outfit-Light') format('svg'),
            url('../assets/fonts/Outfit-Light.ttf') format('truetype'),
            url('../assets/fonts/Outfit-Light.woff') format('woff'),
            url('../assets/fonts/Outfit-Light.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;

html
	margin 0
	padding 0
	height: 100%

body
	margin 0
	padding 0
	height 100%
	position relative
	font-family 'Outfit-Regular', 'ComfortaaLight', Helvetica
	//overflow: hidden

.container
	background-color #EFEFEF

.draw-zone
	position: fixed
	top: 0
	left: 0
	bottom: 0
	right: 0
	z-index: 50
	background-color: var(--drawZoneColor)
	overflow: hidden
	transition: all 0.3s ease-in-out

	&.navigatorOpen
		left: 420px


</style>
